<template>
  <div class="br-pending">
    <div class="br-pending__icon-wrap" aria-hidden="true">
      <img
        :src="docPendingIconUrl"
        class="br-pending__icon"
        width="72"
        height="72"
        alt=""
      />
    </div>
    <h2 class="br-pending__title">{{ $t('lbl_EMPBE_BR_Pending_Title') }}</h2>
    <div class="br-pending__body">
      <p class="br-pending__desc">{{ $t('lbl_EMPBE_BR_Pending_Body') }}</p>
      <p class="br-pending__help">
        {{ $t('lbl_EMPBE_BR_Pending_HelpPrefix') }}
        <a href="#" class="br-pending__link" @click.prevent="$emit('contact')">
          {{ $t('lbl_EMPBE_BR_Pending_ContactUs') }}
        </a>{{ $t('lbl_EMPBE_BR_Pending_HelpSuffix') }}
      </p>
    </div>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrPendingApproval',
  computed: {
    docPendingIconUrl() {
      return BR_LICENSE_ASSETS.docPendingIcon;
    },
  },
};
</script>
